import Routes from './routes';
// import PharmacyOrdersRoutes from './pharmacy-orders-routes';

export default [
  {
    path: Routes.SERVICES_FIND_A_SERVICE_PATH,
    name: Routes.SERVICES_FIND_A_SERVICE_ROUTE,
    component: () => import ('@/views/services/find-service/root-services-find-service'),
    meta: {
      level: 0,
      root: Routes.SERVICES_ROUTE
    },
    // children: PharmacyOrdersRoutes
  },
  {
    path: 'ongoing',
    name: Routes.SERVICES_ONGOING_ROUTE,
    component: () => import ('@/views/services/ongoing/root-services-ongoing'),
    meta: {
      level: 0,
      root: Routes.SERVICES_ROUTE
    }
  },
  {
    path: 'past',
    name: Routes.SERVICES_PAST_ROUTE,
    component: () => import ('@/views/services/past/root-services-past'),
    meta: {
      level: 0,
      root: Routes.SERVICES_ROUTE
    }
  }
]